var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import CompanyAvatar from '@/components/company-avatar.vue';
import ShellIcon from '@/components/shell/shell-icon.vue';
import SelectWorkSpace from '@/components/select-work-space.vue';
import SidemenuBookmarkButton from '@/components/atoms/sidemenu-bookmark-button.vue';
import CanCustomer from '@/mixins/can/customer';
import CanMember from '@/mixins/can/member';
import CanProject from '@/mixins/can/project';
import CanReport from '@/mixins/can/report';
import CanSharingContent from '@/mixins/can/sharing-content';
import CanAttendanceSummary from '@/mixins/can/attendance-summary';
import BaseMixin from '@/mixins/project/base-mixin';
import { ProjectStatus } from '@/types/project';
import { Routes } from '@/types/routes';
import { canAccessSkillsRegister } from '@/components/skills-register/constants/skills-register-access';
import { loadRecentProjects, pushRecentProject } from '@/utils/recent-projects-storage';
var InitialSettingModule = namespace('initial-setting');
var ProjectModule = namespace('project');
var UiSidebarModule = namespace('ui-sidebar');
var TheSideMenu = /** @class */ (function (_super) {
    __extends(TheSideMenu, _super);
    function TheSideMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.routeProjectListPage = Routes.ProjectListPage.name;
        _this.routeProjectNewPage = Routes.ProjectNewPage.name;
        _this.routeCompanyFilesListPage = Routes.CompanyFilesListPage.name;
        _this.routeReportListPage = Routes.ReportListPage.name;
        _this.routeCustomerListPage = Routes.CustomerListPage.name;
        _this.routeMemberListPage = Routes.MemberListPage.name;
        _this.routeSkillsRegisterPage = Routes.SkillsRegisterPage.name;
        _this.routeAttendanceSummaryPage = Routes.AttendanceSummaryPage.name;
        _this.routeSettingsCompanyProfilePage = Routes.SettingsCompanyProfilePage.name;
        _this.routeSettingsCompanySettingPage = Routes.SettingsCompanySettingPage.name;
        _this.routeSettingsConstructionKindListPage = Routes.SettingsConstructionKindListPage.name;
        _this.settingsVisible = false;
        _this.humanResourcesVisible = true;
        _this.recentProjects = [];
        _this.isLoadingFavorites = false;
        return _this;
    }
    Object.defineProperty(TheSideMenu.prototype, "companyId", {
        get: function () {
            return this.$route.params.company_id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TheSideMenu.prototype, "visibleHumanResources", {
        get: function () {
            return this.canIndexMember || this.canAccessSkillsRegister || this.canIndexAttendanceSummary;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TheSideMenu.prototype, "recentProjectsScope", {
        get: function () {
            return { companyId: this.companyId, userId: this.user.uid || this.user.id };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TheSideMenu.prototype, "canAccessSkillsRegister", {
        get: function () {
            return canAccessSkillsRegister(this.company, this.user);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TheSideMenu.prototype, "companyLogoURL", {
        get: function () {
            // ロゴ未設定時は空を返し、CompanyAvatar 側で頭文字モノグラムにフォールバックさせる
            return this.company.logo || '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TheSideMenu.prototype, "displayedFavoriteProjects", {
        /** develop の ProjectList と同様、bookmarked API 結果を client でも★確認 */
        get: function () {
            var _this = this;
            return this.favoriteProjects.filter(function (p) {
                return p.status !== ProjectStatus.completed &&
                    p.status !== ProjectStatus.archived &&
                    _this.isProjectBookmarked(p.id);
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TheSideMenu.prototype, "hasMoreFavoriteProjects", {
        get: function () {
            var _a = this, favoritePaginate = _a.favoritePaginate, favoriteProjects = _a.favoriteProjects;
            if (!favoritePaginate || favoritePaginate.total_count === 0) {
                return false;
            }
            return favoriteProjects.length < favoritePaginate.total_count;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TheSideMenu.prototype, "totalProjectCount", {
        get: function () {
            return this.listPaginate ? this.listPaginate.total_count : 0;
        },
        enumerable: false,
        configurable: true
    });
    TheSideMenu.prototype.mounted = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.user.id) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchMe(this.companyId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.fetchBookmarks()];
                    case 3:
                        _a.sent();
                        return [4 /*yield*/, this.initFavoriteProjects()];
                    case 4:
                        _a.sent();
                        if (!this.listProjects.length) {
                            this.initListProjects();
                        }
                        this.loadRecentProjects();
                        this.$nextTick(function () { return _this.setupFavoritesLoadObserver(); });
                        return [2 /*return*/];
                }
            });
        });
    };
    TheSideMenu.prototype.onCompanyIdChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // ログアウトでルートから company_id が消えた瞬間にも呼ばれる。空のまま取りにいくと
                        // GET /companies//projects が失敗し、await しているためエラーページまで上がって
                        // /sign_in の上に残る。会社が決まっていないときは何もしない
                        if (!this.companyId)
                            return [2 /*return*/];
                        return [4 /*yield*/, this.fetchBookmarks()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.initFavoriteProjects()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TheSideMenu.prototype.onRecentProjectsScopeChange = function (next, prev) {
        // 会社・ユーザーが切り替わったら、その人の履歴に読み直す
        if (next.companyId === prev.companyId && next.userId === prev.userId)
            return;
        this.refreshRecentProjects();
    };
    // methods
    TheSideMenu.prototype.clickMenuEmitter = function () { };
    TheSideMenu.prototype.setupFavoritesLoadObserver = function () {
        var _this = this;
        var root = this.$refs.favoritesScroll;
        var trigger = this.$refs.favoritesLoadTrigger;
        if (!root || !trigger)
            return;
        var observer = new IntersectionObserver(function (_a) {
            var entry = _a[0];
            if (entry.isIntersecting) {
                _this.loadMoreFavoriteProjects();
            }
        }, { root: root, rootMargin: '0px 0px 20px', threshold: 0 });
        observer.observe(trigger);
        this.$once('hook:beforeDestroy', function () { return observer.disconnect(); });
    };
    TheSideMenu.prototype.onFavoritesScroll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dataList, isNearBottom;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dataList = this.$refs.favoritesScroll;
                        if (!dataList)
                            return [2 /*return*/];
                        if (dataList.scrollHeight <= dataList.clientHeight) {
                            return [2 /*return*/];
                        }
                        isNearBottom = dataList.scrollTop + dataList.clientHeight >= dataList.scrollHeight - 20;
                        if (!isNearBottom) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.loadMoreFavoriteProjects()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TheSideMenu.prototype.loadMoreFavoriteProjects = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isLoadingFavorites || !this.hasMoreFavoriteProjects) {
                            return [2 /*return*/];
                        }
                        this.isLoadingFavorites = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, this.fetchFavoriteProjects()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.isLoadingFavorites = false;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    TheSideMenu.prototype.clickSettingMenuHandler = function () {
        this.settingsVisible = false;
    };
    TheSideMenu.prototype.isCurrentProject = function (projectId) {
        var _a;
        var $route = this.$route;
        if (!((_a = $route.name) === null || _a === void 0 ? void 0 : _a.startsWith(Routes.ProjectPage.name)))
            return false;
        return $route.params.id === projectId;
    };
    TheSideMenu.prototype.clickProjectHandler = function (project) {
        if (this.isCurrentProject(project.id))
            return;
        this.recentProjects = pushRecentProject(this.recentProjectsScope, project);
        this.$router.push({
            name: Routes.ProjectDetailPage.name,
            params: { id: project.id },
            query: { forceAsyncData: 'on' }
        });
        this.clickMenuEmitter();
    };
    TheSideMenu.prototype.clickNewProjectHandler = function () {
        this.$router.push({ name: this.routeProjectNewPage });
        this.clickMenuEmitter();
    };
    TheSideMenu.prototype.onRouteProjectIdChange = function () {
        // project detail 側で localStorage 更新後に一覧を同期
        this.refreshRecentProjects();
    };
    TheSideMenu.prototype.refreshRecentProjects = function () {
        this.recentProjects = loadRecentProjects(this.recentProjectsScope);
    };
    TheSideMenu.prototype.loadRecentProjects = function () {
        this.refreshRecentProjects();
    };
    __decorate([
        InitialSettingModule.Getter('user')
    ], TheSideMenu.prototype, "user", void 0);
    __decorate([
        InitialSettingModule.Getter('companies')
    ], TheSideMenu.prototype, "companies", void 0);
    __decorate([
        InitialSettingModule.Getter('company')
    ], TheSideMenu.prototype, "company", void 0);
    __decorate([
        InitialSettingModule.Getter('isBusinessPlan')
    ], TheSideMenu.prototype, "isBusinessPlan", void 0);
    __decorate([
        InitialSettingModule.Getter('isAvailable')
    ], TheSideMenu.prototype, "isAvailable", void 0);
    __decorate([
        InitialSettingModule.Getter('isAdmin')
    ], TheSideMenu.prototype, "isAdmin", void 0);
    __decorate([
        InitialSettingModule.Getter('isBranuUser')
    ], TheSideMenu.prototype, "isBranuUser", void 0);
    __decorate([
        InitialSettingModule.Getter('isMember')
    ], TheSideMenu.prototype, "isMember", void 0);
    __decorate([
        InitialSettingModule.Getter('isGuest')
    ], TheSideMenu.prototype, "isGuest", void 0);
    __decorate([
        Prop({ type: Boolean, default: true })
    ], TheSideMenu.prototype, "collapsible", void 0);
    __decorate([
        UiSidebarModule.Getter('collapsed')
    ], TheSideMenu.prototype, "collapsed", void 0);
    __decorate([
        UiSidebarModule.Action('toggleCollapsed')
    ], TheSideMenu.prototype, "toggleCollapsed", void 0);
    __decorate([
        InitialSettingModule.Action('fetchMe')
    ], TheSideMenu.prototype, "fetchMe", void 0);
    __decorate([
        ProjectModule.Getter('listProjects')
    ], TheSideMenu.prototype, "listProjects", void 0);
    __decorate([
        ProjectModule.Getter('listPaginate')
    ], TheSideMenu.prototype, "listPaginate", void 0);
    __decorate([
        ProjectModule.Getter('favoriteProjects')
    ], TheSideMenu.prototype, "favoriteProjects", void 0);
    __decorate([
        ProjectModule.Getter('favoritePaginate')
    ], TheSideMenu.prototype, "favoritePaginate", void 0);
    __decorate([
        ProjectModule.Getter('bookmarks')
    ], TheSideMenu.prototype, "bookmarks", void 0);
    __decorate([
        ProjectModule.Getter('isProjectBookmarked')
    ], TheSideMenu.prototype, "isProjectBookmarked", void 0);
    __decorate([
        ProjectModule.Action('fetchBookmarks')
    ], TheSideMenu.prototype, "fetchBookmarks", void 0);
    __decorate([
        ProjectModule.Action('initListProjects')
    ], TheSideMenu.prototype, "initListProjects", void 0);
    __decorate([
        ProjectModule.Action('initFavoriteProjects')
    ], TheSideMenu.prototype, "initFavoriteProjects", void 0);
    __decorate([
        ProjectModule.Action('fetchFavoriteProjects')
    ], TheSideMenu.prototype, "fetchFavoriteProjects", void 0);
    __decorate([
        Watch('companyId')
    ], TheSideMenu.prototype, "onCompanyIdChange", null);
    __decorate([
        Watch('recentProjectsScope')
    ], TheSideMenu.prototype, "onRecentProjectsScopeChange", null);
    __decorate([
        Emit('clickMenu')
    ], TheSideMenu.prototype, "clickMenuEmitter", null);
    __decorate([
        Watch('$route.params.id')
    ], TheSideMenu.prototype, "onRouteProjectIdChange", null);
    TheSideMenu = __decorate([
        Component({
            components: {
                ShellIcon: ShellIcon,
                SelectWorkSpace: SelectWorkSpace,
                CompanyAvatar: CompanyAvatar,
                SidemenuBookmarkButton: SidemenuBookmarkButton
            }
        })
    ], TheSideMenu);
    return TheSideMenu;
}(Mixins(CanProject, CanCustomer, CanMember, CanReport, Mixins(BaseMixin, CanSharingContent, CanAttendanceSummary))));
export default TheSideMenu;
